/*if(document.querySelector(".blog-post-content")){
  document.querySelector(".blog-post-content").innerHTML += `<div class="author-box" style="margin-bottom:20px;"><a href="https://grupobelleza.com/blogs/news" class="author-box__avatar" style="border: none;"><img src="https://cdn.shopify.com/s/files/1/0570/6235/9158/files/Monica_Escruela_430x.jpg?v=1750250012" alt=“Mònica Escruela” style="width:62px;height:62px;margin-right:25px;"/></a><div class="author-box__text" style="font-size:17px;"><div class="author-box__name" style="font-size:24px;margin-bottom:10px;"><a href="https://grupobelleza.com/blogs/news" style="border: none;">Mònica Escruela</a></div><div class="author-box__bio" style="margin-bottom:20px;"><a href="https://www.linkedin.com/in/monica-escruela-m%C3%A1rquez-9262a9245/" style="border: none;"><img src="https://cdn.shopify.com/s/files/1/0405/0501/6485/files/LinkedIn_logo_initials_430x.png?v=1725892030" alt="LinkedIn"style="height: 20px;border-radius: 0;padding-right:5px;margin-bottom: -5px;"/>Head of Sales & Marketing</a> </div><a href="https://grupobelleza.com/blogs/news" class="author-box__button" style="font-size:14px;text-transform:uppercase;font-weight:500;padding:6px 15px;background:#000000;color:#FFFFFF;border: none;">Más artículos </a></div></div>`
}*/

/* ============================================================
   NOTIFY ME! PREVENTA — textos de la ficha y del carrito
   La app escribe la fecha como 2026-10-02, sin opción de cambiarla.
   - Ficha y carrito: la fecha pasa a "2 de octubre de 2026".
   - Ficha: el cartel PREVENTA pasa del precio a las fotos.
   - Carrito: el aviso "TIEMPO DE ENTREGA" sale con cualquier producto
     en preventa, no solo cuando se mezcla con productos en stock.
   - Idiomas: la traducción de textos de la app va con candado (plan de
     pago), así que en en/de/fr/it/nl el cartel, el botón, la frase de la
     fecha y el aviso se ponen aquí. El español sale tal cual de la app
     (solo se corrige el "Hacer un pedido" del cartel de la portada).
   - Carrito: "Disponibilidad prevista:" pasa a "El producto se
     enviará a partir del", la línea "Pago: ..." se oculta y el
     nombre del plan ("preorder") pasa a "PRODUCTO EN PREVENTA".
   Todo en el idioma de la tienda (es, en, de, fr, it, nl).
   En el checkout y en el pedido siguen los textos de la app.
   ============================================================ */
(function () {
  var SELECTOR_FECHAS = '.hengam-preorder-description, .hengam-featured-product-description, .cart-items__properties dd';
  var FECHA_ISO = /\b(\d{4})-(\d{2})-(\d{2})\b/g;
  var idioma = (document.documentElement.lang || 'es').slice(0, 2);

  // Etiquetas que la app pone a las propiedades de la línea, en todos los idiomas
  var ETIQUETAS_FECHA = ['Disponibilidad prevista', 'Expected availability', 'Voraussichtliche Verfügbarkeit', 'Disponibilité prévue', 'Disponibilità prevista', 'Verwachte beschikbaarheid'];
  var ETIQUETAS_PAGO = ['Pago', 'Payment', 'Zahlung', 'Paiement', 'Pagamento', 'Betaling'];
  // Textos que pone la app por defecto (se sustituyen solo si coinciden)
  var APP_CARTEL = ['PREVENTA', 'Hacer un pedido', 'Pre-order', 'Vorbestellen', 'Pré-commander', 'Ordine prestabilito', 'Voorafgaande bestelling'];
  var APP_BOTON = ['PREVENTA', 'Reserva ahora', 'Pre-order now', 'jetzt vorbestellen', 'Pré commandez maintenant', 'Preordinalo ora', 'Bestel nu vooraf'];
  var APP_AVISO_TITULO = ['Shipping Notice', 'TIEMPO DE ENTREGA'];
  var APP_AVISO_TEXTO = ['Your order contains items with different delivery dates.', 'Tu pedido se enviará cuando todos los productos en preventa estén disponibles.'];
  // ficha y aviso a null en español: ahí manda lo que se escriba en la app
  var TEXTOS = {
    es: { envio: 'El producto se enviará a partir del', preventa: 'PRODUCTO EN PREVENTA', cartel: 'PREVENTA', boton: 'PREVENTA', ficha: null, avisoTitulo: null, avisoTexto: null },
    en: { envio: 'This product will ship from', preventa: 'PRE-ORDER PRODUCT', cartel: 'PRE-ORDER', boton: 'PRE-ORDER', ficha: 'This item will ship from {fecha}', avisoTitulo: 'DELIVERY TIME', avisoTexto: 'Your order will ship once all pre-order items are available.' },
    de: { envio: 'Versand ab dem', preventa: 'VORBESTELLUNG', cartel: 'VORBESTELLUNG', boton: 'VORBESTELLUNG', ficha: 'Wir versenden diesen Artikel ab dem {fecha}', avisoTitulo: 'LIEFERZEIT', avisoTexto: 'Deine Bestellung wird versendet, sobald alle vorbestellten Artikel verfügbar sind.' },
    fr: { envio: 'Expédition à partir du', preventa: 'PRODUIT EN PRÉCOMMANDE', cartel: 'PRÉCOMMANDE', boton: 'PRÉCOMMANDE', ficha: 'Nous expédierons cet article à partir du {fecha}', avisoTitulo: 'DÉLAI DE LIVRAISON', avisoTexto: 'Votre commande sera expédiée dès que tous les articles en précommande seront disponibles.' },
    it: { envio: 'Spedizione a partire dal', preventa: 'PRODOTTO IN PREORDINE', cartel: 'PREORDINE', boton: 'PREORDINE', ficha: 'Spediremo questo articolo a partire dal {fecha}', avisoTitulo: 'TEMPI DI CONSEGNA', avisoTexto: 'Il tuo ordine verrà spedito quando tutti i prodotti in preordine saranno disponibili.' },
    nl: { envio: 'Verzending vanaf', preventa: 'PRODUCT IN VOORVERKOOP', cartel: 'VOORVERKOOP', boton: 'VOORVERKOOP', ficha: 'We verzenden dit artikel vanaf {fecha}', avisoTitulo: 'LEVERTIJD', avisoTexto: 'Je bestelling wordt verzonden zodra alle voorverkoopartikelen beschikbaar zijn.' }
  };
  var textos = TEXTOS[idioma] || TEXTOS.es;
  var formato;

  try {
    formato = new Intl.DateTimeFormat(idioma, {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      timeZone: 'UTC'
    });
  } catch (error) {
    return;
  }

  function formatearFecha(texto, anio, mes, dia) {
    var fecha = new Date(Date.UTC(+anio, +mes - 1, +dia));
    return isNaN(fecha.getTime()) ? texto : formato.format(fecha);
  }

  function formatearElemento(elemento) {
    var recorrido = document.createTreeWalker(elemento, NodeFilter.SHOW_TEXT);
    var nodo;
    while ((nodo = recorrido.nextNode())) {
      if (/\d{4}-\d{2}-\d{2}/.test(nodo.nodeValue)) {
        nodo.nodeValue = nodo.nodeValue.replace(FECHA_ISO, formatearFecha);
      }
    }
  }

  // Cambia el primer texto con contenido del elemento si es uno de los de la
  // app. Se toca el nodo de texto existente (no se reemplaza) para que la app
  // pueda seguir actualizándolo, por ejemplo al cambiar de talla.
  function cambiarTexto(elemento, conocidos, nuevo) {
    if (!nuevo) return;
    var recorrido = document.createTreeWalker(elemento, NodeFilter.SHOW_TEXT);
    var nodo;
    while ((nodo = recorrido.nextNode())) {
      var actual = nodo.nodeValue.trim();
      if (!actual) continue;
      if (actual !== nuevo && conocidos.indexOf(actual) !== -1) nodo.nodeValue = nuevo;
      return;
    }
  }

  function ajustarDescripcion(elemento) {
    // "Expected availability: 2026-10-15 / Payment: ..." pasa a la frase propia
    if (!textos.ficha) return;
    var recorrido = document.createTreeWalker(elemento, NodeFilter.SHOW_TEXT);
    var nodo;
    while ((nodo = recorrido.nextNode())) {
      var fecha = nodo.nodeValue.match(/(\d{4})-(\d{2})-(\d{2})/);
      if (fecha) nodo.nodeValue = textos.ficha.replace('{fecha}', formatearFecha(fecha[0], fecha[1], fecha[2], fecha[3]));
    }
  }

  function ajustarTextosApp() {
    document.querySelectorAll('.hengam-preorder-badge, .hengam-featured-product-badge, .hengam-preorder-collection-badge, .hengam-preorder-landing-badge').forEach(function (e) { cambiarTexto(e, APP_CARTEL, textos.cartel); });
    document.querySelectorAll('.hengam-preorder-button, .hengam-featured-product-button').forEach(function (e) { cambiarTexto(e, APP_BOTON, textos.boton); });
    document.querySelectorAll('.hengam-preorder-description, .hengam-featured-product-description').forEach(ajustarDescripcion);
    document.querySelectorAll('.nm-mixed-cart-alert__title').forEach(function (e) { cambiarTexto(e, APP_AVISO_TITULO, textos.avisoTitulo); });
    document.querySelectorAll('.nm-mixed-cart-alert__body').forEach(function (e) { cambiarTexto(e, APP_AVISO_TEXTO, textos.avisoTexto); });
  }

  function ajustarPropiedad(fila) {
    var dt = fila.querySelector('dt');
    if (!dt) return;
    var etiqueta = dt.textContent.trim().replace(/:$/, '').trim();
    if (ETIQUETAS_PAGO.indexOf(etiqueta) !== -1) {
      if (fila.style.display !== 'none') fila.style.display = 'none';
    } else if (ETIQUETAS_FECHA.indexOf(etiqueta) !== -1) {
      dt.textContent = textos.envio + ' ';
    }
  }

  function ajustarPlan(parrafo) {
    // Párrafo con el nombre del plan de venta, justo debajo de las propiedades
    if (parrafo.textContent.trim() !== textos.preventa) parrafo.textContent = textos.preventa;
  }

  function ajustarFicha() {
    // La app pone su cartel junto al precio solo si la talla elegida está en
    // preventa; se copia su texto a la galería para mostrarlo sobre las fotos
    var galeria = document.querySelector('media-gallery');
    if (!galeria) return;
    var cartel = document.querySelector('.hengam-product-price-wrapper .hengam-preorder-badge');
    var texto = cartel ? cartel.textContent.trim() : '';
    if (texto) {
      var valor = JSON.stringify(texto);
      if (galeria.style.getPropertyValue('--muare-preventa') !== valor) galeria.style.setProperty('--muare-preventa', valor);
      if (!galeria.hasAttribute('data-preventa')) galeria.setAttribute('data-preventa', '');
    } else if (galeria.hasAttribute('data-preventa')) {
      galeria.removeAttribute('data-preventa');
    }
  }

  function ajustarAvisoCarrito() {
    // La app solo muestra "TIEMPO DE ENTREGA" si el carrito mezcla preventa
    // y stock; se marca <html> cuando hay cualquier línea en preventa (la que
    // lleva el párrafo del plan) y el CSS lo muestra también en ese caso
    var hayPreventa = !!document.querySelector('.cart-items .cart-items__variants + p');
    var raiz = document.documentElement;
    if (hayPreventa !== raiz.hasAttribute('data-carrito-preventa')) raiz.toggleAttribute('data-carrito-preventa', hayPreventa);
  }

  // Se ejecuta dentro del propio MutationObserver (antes de pintar), así el
  // cliente no llega a ver los textos originales cuando el carrito se recarga.
  // Cada ajuste solo cambia algo la primera vez, así que no entra en bucle.
  function revisar() {
    ajustarTextosApp();
    ajustarFicha();
    ajustarAvisoCarrito();
    document.querySelectorAll('.cart-items__properties').forEach(ajustarPropiedad);
    document.querySelectorAll('.cart-items__details .cart-items__variants + p').forEach(ajustarPlan);
    document.querySelectorAll(SELECTOR_FECHAS).forEach(formatearElemento);
  }

  new MutationObserver(revisar).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  revisar();
})();

/* ============================================================
   FICHA DE PRODUCTO — barra de compra fija abajo en móvil
   Cuando el botón de compra sale de la pantalla aparece abajo una
   barra con la cantidad y el mismo botón (como en delamur.com). La
   barra no compra por su cuenta: pulsa el botón real del tema, así
   sigue funcionando todo lo que cuelga de él (preventa, cajón del
   carrito, avisos). Copia su texto y si está desactivado (Agotado).
   ============================================================ */
(function () {
  var MOVIL = window.matchMedia('(max-width: 749px)');

  function iniciar() {
    var detalles = document.querySelector('.product-details');
    var boton = detalles && detalles.querySelector('add-to-cart-component button[type="submit"]');
    if (!boton) return;
    var cantidad = detalles.querySelector('quantity-selector-component input[name="quantity"]');

    var barra = document.createElement('div');
    barra.className = 'muare-barra-compra';
    barra.innerHTML =
      (cantidad ? '<div class="muare-barra-compra__cantidad">' +
        '<button type="button" data-paso="-1" aria-label="-">&minus;</button>' +
        '<input type="number" inputmode="numeric" min="1" value="1" aria-label="Cantidad">' +
        '<button type="button" data-paso="1" aria-label="+">+</button>' +
      '</div>' : '') +
      '<button type="button" class="muare-barra-compra__boton"></button>';
    document.body.appendChild(barra);

    var botonBarra = barra.querySelector('.muare-barra-compra__boton');
    var cantidadBarra = barra.querySelector('input');

    function sincronizarBoton() {
      var texto = (boton.innerText || boton.textContent).trim().split('\n')[0].trim();
      if (botonBarra.textContent !== texto) botonBarra.textContent = texto;
      if (botonBarra.disabled !== boton.disabled) botonBarra.disabled = boton.disabled;
    }

    function pasarCantidad(valor) {
      valor = Math.max(1, parseInt(valor, 10) || 1);
      if (cantidadBarra) cantidadBarra.value = valor;
      if (cantidad && cantidad.value !== String(valor)) {
        cantidad.value = valor;
        cantidad.dispatchEvent(new Event('input', { bubbles: true }));
        cantidad.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    barra.addEventListener('click', function (evento) {
      var paso = evento.target.closest('[data-paso]');
      if (paso) pasarCantidad((parseInt(cantidadBarra.value, 10) || 1) + parseInt(paso.dataset.paso, 10));
    });
    if (cantidadBarra) cantidadBarra.addEventListener('change', function () { pasarCantidad(cantidadBarra.value); });
    botonBarra.addEventListener('click', function () { if (!boton.disabled) boton.click(); });

    // Se muestra cuando el botón real no está en pantalla (solo en móvil)
    var raiz = document.documentElement;
    var botonVisible = true;
    function actualizarVisibilidad() {
      var mostrar = MOVIL.matches && !botonVisible;
      if (mostrar && cantidad && cantidadBarra) cantidadBarra.value = cantidad.value || 1;
      if (mostrar !== raiz.hasAttribute('data-barra-compra')) raiz.toggleAttribute('data-barra-compra', mostrar);
    }
    new IntersectionObserver(function (entradas) {
      botonVisible = entradas[0].isIntersecting;
      actualizarVisibilidad();
    }).observe(boton);
    if (MOVIL.addEventListener) MOVIL.addEventListener('change', actualizarVisibilidad);

    // El texto del botón cambia con la talla y con la preventa
    new MutationObserver(sincronizarBoton).observe(boton, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    sincronizarBoton();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
